'use strict';

angular.module('contentful').directive('cfContentTypeList', () => ({
  template: JST.content_type_list(),
  restrict: 'A',
  controller: 'ContentTypeListController'
}));



// WEBPACK FOOTER //
// ./src/javascripts/components/tabs/content_type_list/content_type_list_directive.js